module.exports = __webpack_public_path__ + "img/tabler-tool-used.3bffa598.svg";